import { IMtaActions, IMtaFormNames, IMtaState } from '../../../../../../../services/mta/models';
import * as React from 'react';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as headerActions } from '../../../../../../../services/header/reducer';
import { push } from 'react-router-redux';
import { mtaActions } from '../../../../../../../services/mta/actions';
import { IHeaderActions } from '../../../../../../../services/header/models';
import CancelHeader from '../components/CancelHeader';
import { IAuthState } from '../../../../../../../services/auth/models';
import { formValueSelector, reduxForm } from 'redux-form';
import { IQuoteState } from '../../../../../../../services/quote/models';
import { Button } from 'react-bootstrap';
import { format } from 'date-fns';

interface ICancelPolicyCompleteProps {
  mta: IMtaState;
  auth: IAuthState;
  quote: IQuoteState;
  dispatch: any;
  history: any;
  formValues: any;
  actions: {
    header: IHeaderActions;
    push(path: string);
    mta: IMtaActions;
  };
}

class CancelPolicyComplete extends React.Component<ICancelPolicyCompleteProps, any> {
  constructor(props) {
    super(props);
    const { actions } = props;
    actions.mta.setCompleteMTA();
    window.scrollTo(0, 0);
  }

  private handleGoBack = () => {
    const { actions } = this.props;
    actions.push('/account/summary');
  }

  private renderSuccessContent = () => {
    const { mta, auth, formValues, quote } = this.props;
    // const policyId = mta.afterSubmit.policyId || quote.application?.renewingPolicyId;
    const policyNumber = mta.selectedPolicy?.policyNumber;
    const customerFirstName = auth.customer?.firstName;
    const isRenewal = get(formValues, 'meta.cancel.renewal', false)
    const isAnnual = mta.selectedPolicy.metadata.scheme_type === 'annual';
    const returnPremium = mta?.afterSubmit?.returnPremium || 0.00
    const title = isRenewal ? `Cancel Renewal Quote ${get(quote, 'application.quoteReference')}` : `Cancel Policy ${policyNumber}`;
    const today = format(new Date(), 'dd/MM/yyyy')
    return (
      <div>
        <div className={'mt-30'}/>
        <CancelHeader
          title={title}
          showText={false}
          icon={'handshake'}
          showDefaqto={false}
        />
        <div className={'white-card'}>
          <p className="mb-25">
            We're sad to see you go {customerFirstName}.
          </p>
          <p>
            {isRenewal ? 'This is a confirmation that your renewal quote has been cancelled effective from ' + today + '.' : 'This is a confirmation that your policy has been cancelled effective from ' + today + '.'}
          </p>
          {!isRenewal && +returnPremium > 0 && (
            <p>£{returnPremium} has been refunded back to the card we hold on file.</p>
          )}
          <p>{isAnnual ?
            <b>We'd love to have you back the next time you travel – remember to use discount code RETURN10 for 10% off
              your next Annual Multi-Trip policy with us!</b> : 'We\'d love to have you back next time you travel.'}</p>
        </div>
        <div className={'mt-15'}>
          <Button
            type="button"
            bsStyle={'primary'}
            className="secondary-button medium-width"
            onClick={this.handleGoBack}>
            RETURN TO POLICY
          </Button>
        </div>
      </div>
    );
  }

  private renderFailedContent = () => {
    return (
      <div>
        <h2>Make a Change - There has been a problem</h2>
        <p className="mb-25">
          Unfortunately there has been a problem cancelling your policy , please see
          our <a className="pointer" href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>Contact
          Us</a> page for
          details on how to get in touch.
        </p>
      </div>
    );
  }

  public render() {
    const { mta } = this.props;
    if (mta.afterSubmit.success && mta.afterSubmit.changes !== 0) {
      return this.renderSuccessContent();
    } else {
      return this.renderFailedContent();
    }
  }
}

let selector;
export default flow([
  reduxForm({
    form: IMtaFormNames.CANCEL_FORM,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.CANCEL_FORM);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(state, 'data');
      return {
        mta: state.mta,
        auth: state.auth,
        quote: state.quote,
        formValues: values,
      }
    },
    (dispatch) => ({
      actions: {
        header: bindActionCreators({ ...headerActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(CancelPolicyComplete);
